export const constants = {};

export const requestType = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
};

export const endPoints = {
  //Auth
  login: "admin/login",
  createVendor: "user/registerByAdmin",

  //Dashboard
  dashboardData: "admin/dashboard/fetch",

  //User
  allUser: "admin/fetch/users",
  updateUser: "admin/update/user",

  //Vendors
  allVendors: "admin/fetch/vendors",
  updateVendor: "admin/update/vendor",

  //Category
  createCategory: "admin/create/category",
  fetchCategory: "admin/fetch/category",

  //FAQ's
  fetchFaq: "admin/fetch/faq",
  createFaq: "admin/create/faq",
  deleteFaq: "admin/delete/faq",
  updateFaq: "admin/update/faq",

  //Banners
  fetchBanners: "admin/fetch/banner",
  createBanners: "admin/create/banner",
  deleteBanners: "admin/delete/banner",

  //Payment
  commissionHistory: "admin/fetch/commision-history",
  withdrawalHistory: "admin/fetch/withdraw-history",
  sponsoredHistory: "admin/fetch/sponsered-history",

  //Vendor
  updateVendorProfile: "vendor/updateProfile",
  getVendorDetails: "admin/vendor/details",
  getVendorOrders: "vendor/order/fetch-all",

  // Return Orders
  getAllReturnOrders: "admin/fetch/returns",
  returnDetails: "user/fetch/returnDetails",
  updateReturnOrderStatus: "admin/return/update",

  // Settings
  settings: "admin/settings/fetch",
  updateSettings: "admin/settings/update",
};
